<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchMaterial" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสวัตถุดิบ"
                        aria-label="Search"
                        v-model="search.code"/>
                    &nbsp;
                    <b-form-select v-model="search.type"
                                   :options="material_type">
                    </b-form-select>
                    &nbsp;
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchMaterial">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <router-link to="materials-information">
                        <template v-if="canInventoryMaterialsUpdate">
                            <button
                                    class="btn btn-warning my-2 my-sm-0"
                                    type="button">
                                <icon name="plus"></icon>
                                เพิ่มวัตถุดิบ
                            </button>
                        </template>
                    </router-link>
                    &nbsp;
                    <button class="btn btn-primary"
                            @click="showPrintMaterialReport"
                            type="button">
                        <icon name="print"></icon>
                        รายงานการสั่งซื้อ
                    </button>
                </form>
            </div>
        </nav>
        <span style="color: red; font-size: 15px;padding-left: 15px">สามารถกดสั่งซื้อได้เฉพาะ คุณมด,เฮีย,คุณนิคมเท่านั้น</span>
        <div class="col-12 table-responsive" >
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">สั่งซื้อวัตถุดิบ</th>
                    <th scope="col">สถานะการสั่งซื้อ</th>
                    <th scope="col">นำเข้าวัตถุดิบ</th>
                    <th scope="col">เบิกวัตถุดิบ</th>
                    <th scope="col">รหัสวัตถุดิบ</th>
                    <th scope="col">รายการ</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <template v-if="canInventoryMaterialsUpdate">
                        <th scope="col">แก้ไข</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in material">
                    <td>
                        <template v-if="canViewSuperAdmin || user.id==3">
                            <a v-if="data.quantity < data.min_quantity"
                               @click="showPreOrderMaterailsModal(data.id)">
                                <img src="@/assets/shopping-basket.png" width="40px"/>
                            </a>
                            <div v-else>
                                <img src="@/assets/shopping-basket_green.png" width="40px"/>
                            </div>
                        </template>
                        <template v-else>
                            <a v-if="data.quantity < data.min_quantity" style="cursor: not-allowed">
                                <img src="@/assets/shopping-basket.png" width="40px"/>
                            </a>
                            <div v-else>
                                <img src="@/assets/shopping-basket_green.png" width="40px" style="cursor: not-allowed"/>
                            </div>
                        </template>
                    </td>
                    <td>
                        {{data.preOrder_status_name}}
                    </td>
                    <td>
                        <template>
                            <a @click="showMaterialImportModal(data.id)">
                                <img src="@/assets/plus_icon.png" width="40px"/>
                            </a>
                        </template>
                    </td>
                    <td>
                        <a @click="showMaterialExportModal(data.id)">
                            <img src="@/assets/delete_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>{{ data.code }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.quantity | currency }} {{data.type_unit}}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <template v-if="canInventoryMaterialsUpdate">
                        <td>
                            <a @click="goToMaterialInformation(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp;&nbsp;
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <!--paginate-->
        <div v-if="material.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getMaterialPage">
            </vue-pagination>
        </div>
        <!--
            -------------------Modal Pre Order--------------------------------
        -->
        <b-modal
                hide-footer
                ref="pre_order"
                id="preOrder"
                title="สั่งซื้อวัตถุดิบ">
            <pre-order-materials @submit="saveMaterialToPreOrder">
            </pre-order-materials>
        </b-modal>
        <!--
            -------------------Modal Import Data--------------------------------
        -->
        <b-modal
            hide-footer
            ref="import_data"
            id="import"
            title="เพิ่มวัตถุดิบเข้าคลัง">
            <import-material-modal @submit="saveMaterialImport">
            </import-material-modal>
        </b-modal>
        <!--
            -------------------Modal export Data--------------------------------
        -->
        <b-modal
            hide-footer
            ref="export_data"
            id="export"
            title="เบิกวัตถุดิบ">
            <export-material-modal
                    @submit="saveMaterialExport">
            </export-material-modal>
        </b-modal>

        <!--
            -------------------Modal print report material--------------------------------
        -->
        <b-modal
                hide-footer
                ref="print_report_material"
                id="export"
                title="รายงานการสั่งซื้อวัตถุดิบ">
            <material-print-report @submit="printMaterialReport">
            </material-print-report>
        </b-modal>
        <br />
    </div>
</template>

<script>
import { mapState } from "vuex";
import ExportMaterialModal from "../Export/ExportMaterialModal";
import ImportMaterialModal from "../Import/ImportMaterialModal";
import VuePagination from "../../Pagination";
import { domain } from "../../../util/Constants";

import {
    canInventoryMaterialsView,
    canInventoryMaterialsImport,
    canInventoryMaterialsExport,
    canInventoryMaterialsUpdate,
    canInventoryProductsView,
    canViewSuperAdmin,
} from "../../../util/Permissions";
import PreOrderMaterials from "../Import/PreOrderMaterials";
import MaterialPrintReport from "./MaterialPrintReport";

export default {
    components: {
        MaterialPrintReport,
        PreOrderMaterials,
        VuePagination,
        ImportMaterialModal,
        ExportMaterialModal
    },
    name: "materials",
    data() {
        return {
            material : [],
            dataPaginate : {
                current_page : 1,
                from : 1,
                last_page : 1,
                per_page : 1,
                total : 1,
                to : 1
            },
            id: "",
            event_submit : false,
        };
    },
    created() {
        this.$store.dispatch("Common/getMaterialType");
        this.$store.dispatch("Products/clearSearch");
        this.getMaterialPage();
    },
    computed: {
        canInventoryMaterialsView,
        canInventoryMaterialsImport,
        canInventoryMaterialsExport,
        canInventoryMaterialsUpdate,
        canInventoryProductsView,
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            search:state =>{
                return state.Material.search;
            },
            material_type : state=>{
                return [
                    {
                        value : "",
                        text : "เลือกประเภทวัตถุดิบ"
                    },
                    ...state.Common.material_type.map(type=>({
                        value: type.id,
                        text: type.name
                    }))
                ]
            }
        })
    },
    methods: {
        //Modal
        showMaterialImportModal(id) {
            this.id = id;
            this.showMaterialData(this.id);
            this.$refs.import_data.show();
        },
        hideMaterialImportModal() {
            this.$refs.import_data.hide();
        },
        showMaterialExportModal(id) {
            this.id = id;
            this.showMaterialData(this.id);
            this.$refs.export_data.show();
        },
        hideMaterialExportModal() {
            this.$refs.export_data.hide();
        },
        showPreOrderMaterailsModal(id) {
            this.id = id;
            this.showMaterialData(this.id);
            this.$refs.pre_order.show();
        },
        hidePreOrderMaterailsModal() {
            this.$refs.pre_order.hide();
        },
        showPrintMaterialReport() {
            this.$refs.print_report_material.show();
        },
        hidePrintMaterialReport() {
            this.$refs.print_report_material.hide();
        },
        //API
        saveMaterialToPreOrder(submitData) {
            if(submitData!=0){
                submitData.quantity = parseInt(submitData.quantity);
                this.$store.dispatch('PreOrder/create',submitData).then(()=>{
                    this.hidePreOrderMaterailsModal();
                    this.getMaterialPage();
                })
            }
            this.hidePreOrderMaterailsModal();
        },
        saveMaterialImport(submitData){
            if(submitData != 0){
                this.$store.dispatch("ImportMaterial/create",submitData).then(()=>{
                    this.$router.push("/materials-import")
                })
            }
            this.hideMaterialImportModal();
        },
        saveMaterialExport(submitData) {
            if(submitData!=="cancel"){
                this.$store
                    .dispatch("ExportMaterial/create", submitData)
                    .then(data => {
                        if(!data){
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                        }
                        else{
                            this.$router.push({
                                name: "materials-export"
                            });
                            this.hideMaterialExportModal();
                        }
                    });
            }
            this.hideMaterialExportModal();
        },
        showMaterialData(id) {
            this.$store.dispatch("Material/show", id);
        },
        searchMaterial() {
            this.event_submit = true;
            this.$store.dispatch("Material/search", {
                page : 1,
                data : this.search
            }).then(res=>{
                this.material = res.data;
                this.dataPaginate = {
                    current_page : res.current_page,
                    from : res.form,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.to
                }
            });
        },
        //function
        goToMaterialInformation(id) {
            this.$router.push({
                name: "materials-information",
                params: { id }
            });
        },
        getMaterialPage(){
            const page = this.dataPaginate.current_page;
            if(this.event_submit){
                this.$store.dispatch("Material/search", {
                    page : page,
                    data : this.search
                }).then(res=>{
                    this.material = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.form,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                });
            }else{
                this.$store.dispatch("Material/get",page).then(res=>{
                    this.material = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.form,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                });
            }
        },
        printMaterialReport(value){
            console.log(value);
            if(value){
                window.open(domain+"/material_report?type="+value.type+
                "&start_date="+value.start_date+
                "&end_date="+value.end_date+"&vendor_id="+value.vendor_id,'_blank');
            }
            this.hidePrintMaterialReport();
        }
    }
};
</script>

<style lang="scss" scoped>
    a{
        cursor: pointer;
    }
</style>
